export const TOGGLE_PROJECT_PIPELINES = 'TOGGLE_PROJECT_PIPELINES';
export const PROJECT_DETAIL_VIEW = 'PROJECT_DETAIL_VIEW';
export const PROJECT_DETAIL_VIEW_ACCESS_TAB = 'Access';
